export default __webpack_public_path__ + "static/media/ronbo-TN.d64fd123.png";